import {RouteRecordRaw} from "vue-router"
import StudentPublicRegisterView from "@/views/Student/PublicRegisterView.vue"
import StudentContainerView from "@/views/Student/StudentContainerView.vue"

const StudentDashboardView = () => import('@/views/Student/DashboardView.vue')
const StudentCourseListView = () => import('@/views/Student/CourseListView.vue')
const StudentGalaRegistrationView = () => import('@/views/Student/GalaRegistrationView.vue')
const StudentGalaListView = () => import('@/views/Student/GalaListView.vue')
const StudentNextSeasonRegisterView = () => import('@/views/Student/NextSeasonRegisterView.vue')

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/register',
        name: 'student_register',
        component: StudentPublicRegisterView
    },
    {
        path: '/student',
        component: StudentContainerView,
        children: [
            {
                path: '',
                name: 'student_dashboard',
                component: StudentDashboardView,
            },
            {
                path: 'my_courses',
                name: 'student_course_list',
                component: StudentCourseListView,
            },
            {
                path: 'next-season-register',
                name: 'student_next_season_register',
                component: StudentNextSeasonRegisterView,
            },
            {
                path: 'gala_registration',
                name: 'student_gala_registration',
                component: StudentGalaRegistrationView
            },
            {
                path: 'my_galas',
                name: 'student_gala_list',
                component: StudentGalaListView,
            }
        ]
    },
]
